import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { reduxForm } from 'redux-form';

import { UserProfile } from 'fitbeat.gym-core';
import UserNutritionReviewPopup from './UserNutritionReviewPopup';
interface IProps {
  t: (key: string) => string;
  userProfile: UserProfile;
  isUserNutritionReviewVisible: boolean;
  isNutritionReviewBodyVisible: boolean;
  latestNutritionRating: Date;
  nutritionRating: number;
  onRatingPress(rating: number): void;
  setNutritionRating(rating: number): void;
  getNutritionRatingData(userProfile: UserProfile): void;
  toggleNutritionReviewBody(): void;
}

class UserNutritionReview extends Component<IProps, any> {





  render() {
      return (
        <UserNutritionReviewPopup
          lastReviewDate={this.props.latestNutritionRating}
          onRatingPress={this.props.onRatingPress}
          nutritionRating={this.props.nutritionRating}
        />
      );
  }
}


const UserNutritionReviewTranslate = translate(['nutrition'], { wait: true })(UserNutritionReview);
const UserNutritionReviewRedux = reduxForm({ form: 'UserNutritionReviewForm' })(UserNutritionReviewTranslate);
export default UserNutritionReviewRedux;
